// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VBg8","rootNoMargin":"styles_rootNoMargin__3U-3P"};